var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VChart',_vm._g({staticStyle:{"height":"90%"},attrs:{"option":_vm.chartOpt,"loading":_vm.loading,"autoresize":""}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }